// ----------------------------------------------------------------------
// Stripe Connect Translations - Portuguese
// ----------------------------------------------------------------------

export const stripeConnectPt = {
  stripe_connect: {
    // Account selector
    select_account: 'Selecionar conta Stripe',
    destination_account: 'Conta de destino',
    no_accounts_available: 'Nenhuma conta Stripe disponível para transferências. Por favor, configure uma conta Stripe nas configurações da organização.',
    personal_account: 'Conta pessoal',
    organization_account: 'Conta da organização',
    transfer_destination: 'Destino da transferência',
    transfer_helper_text: 'A parte do proprietário será transferida para esta conta após o evento',
    select_account_for_transfer: 'Selecione qual conta Stripe deve receber a parte do proprietário',

    // Account status
    status_active: 'Ativo',
    status_pending: 'Pendente',
    status_inactive: 'Inativo',

    // Alerts and messages
    legal_verification: 'Verificação legal necessária',
    complete_stripe_setup: 'Concluir configuração do Stripe',
    complete_setup_short: 'Concluir',
    setup_stripe_account: 'Configurar conta Stripe',
    setup_short: 'Configurar',
    alert_stripe_incomplete_setup: 'A configuração da sua conta Stripe está incompleta. Por favor, complete a verificação para receber pagamentos.',
    alert_stripe_configuration_title: 'Uma conta Stripe Connect é necessária para receber pagamentos pelos seus eventos.',

    // Multi-account messages
    no_stripe_for_org: 'Nenhuma conta Stripe para esta organização',
    no_stripe_for_org_named: 'Nenhuma conta Stripe para "{{orgName}}"',
    using_personal_account_disclaimer: 'Usando sua conta Stripe pessoal.',
    configure_org_account: 'Configurar conta da organização',
    has_stripe_on_other_orgs: 'Você tem contas Stripe em outras organizações. Configure esta organização para usar uma conta existente ou crie uma nova nas configurações da organização.',
    has_legacy_account: 'Você tem uma conta Stripe pessoal. Ative-a para esta organização ou crie uma nova nas configurações da organização.',
    configure_in_settings: 'Configurar nas definições',
    setup_in_org_settings: 'Por favor, configure as contas Stripe nas configurações da organização',
    personal_account_available: 'Conta Stripe pessoal disponível',
    personal_account_hint: 'Você tem uma conta Stripe pessoal que pode ser habilitada para "{{orgName}}". Vá para as configurações da organização para configurar as contas de pagamento.',
    org_setup_incomplete_personal_available: 'Configuração de pagamento da organização incompleta',
    org_setup_incomplete_personal_hint: 'A configuração do Stripe para "{{orgName}}" ainda não está completa. Sua conta pessoal está sendo usada enquanto isso. Complete a configuração da organização quando quiser.',
    alert_stripe_incomplete_setup_org: 'A configuração da conta Stripe para "{{orgName}}" está incompleta. Por favor, complete o processo de verificação para começar a receber pagamentos pelos seus eventos.',
    alert_stripe_configuration_org: 'Para receber pagamentos por eventos em "{{orgName}}", você precisa configurar uma conta Stripe Connect. Isso é obrigatório para conformidade legal e processamento seguro de pagamentos.',

    // Stripe accounts manager
    stripe_accounts: 'Contas Stripe',
    stripe_accounts_subtitle: 'Gerenciar contas Stripe Connect para esta organização',
    add_account: 'Adicionar conta',
    add_new_account: 'Adicionar nova conta',
    sync_account: 'Sincronizar conta',
    set_as_primary: 'Definir como principal',
    deactivate_account: 'Desativar conta',
    edit_account: 'Editar conta',
    account_name: 'Nome da conta',
    account_description: 'Descrição',
    account_name_placeholder: 'ex: Conta principal, Conta festival',
    account_description_placeholder: 'Descrição opcional para esta conta',
    primary_account: 'Conta principal',
    primary_account_badge: 'Principal',

    // Account stats
    total_accounts: 'Total de contas',
    active_accounts: 'Contas ativas',
    pending_accounts: 'Contas pendentes',
    inactive_accounts: 'Contas inativas',

    // Account details
    account_id: 'ID da conta',
    charges_enabled: 'Cobranças habilitadas',
    payouts_enabled: 'Pagamentos habilitados',
    details_submitted: 'Detalhes enviados',
    country: 'País',
    currency: 'Moeda',
    business_type: 'Tipo de negócio',
    last_synced: 'Última sincronização',
    created_at: 'Criado em',
    created_by: 'Criado por',

    // Actions
    complete_onboarding: 'Concluir cadastro',
    view_dashboard: 'Ver painel do Stripe',
    refresh_status: 'Atualizar status',

    // Confirmations
    confirm_deactivate: 'Tem certeza de que deseja desativar esta conta?',
    confirm_deactivate_description: 'Contas desativadas não podem receber pagamentos. Você pode reativá-las posteriormente.',
    confirm_set_primary: 'Definir esta conta como principal?',
    confirm_set_primary_description: 'A conta principal será usada por padrão para novos eventos.',

    // Success messages
    account_created: 'Conta Stripe criada com sucesso',
    account_updated: 'Conta Stripe atualizada com sucesso',
    account_synced: 'Status da conta sincronizado com sucesso',
    account_deactivated: 'Conta desativada com sucesso',
    primary_account_set: 'Conta principal atualizada com sucesso',

    // Error messages
    error_creating_account: 'Erro ao criar conta Stripe',
    error_updating_account: 'Erro ao atualizar conta Stripe',
    error_syncing_account: 'Erro ao sincronizar status da conta',
    error_deactivating_account: 'Erro ao desativar conta',
    error_setting_primary: 'Erro ao definir conta principal',
    error_creating_stripe_link: 'Erro ao criar link de cadastro do Stripe',
    error_creating_stripe_account: 'Erro ao criar conta Stripe',

    // Legacy account
    use_legacy_account: 'Usar conta pessoal',
    use_legacy_account_description: 'Usar sua conta Stripe pessoal quando nenhuma conta da organização estiver disponível',
    legacy_account_active: 'Sua conta Stripe pessoal está ativa e pode ser usada',
    legacy_account_pending: 'Sua conta Stripe pessoal requer verificação adicional',
  },

  // Shares distribution (new keys - existing keys like shares_distribution, reservation_details, reservations are in main locale)
  shares_distribution_subheader: 'Visão geral da distribuição de receitas para este evento',
  total_sales: 'Vendas totais',

  // Common
  this_organization: 'esta organização',
};

export default stripeConnectPt;
